export const generateRescheduleCQL = (externalEventId?: string) => {
  if (!externalEventId) {
    // Cannot generate CQL without an externalEventId
    return null;
  }
  return `(update_events (find_events (event_id "${externalEventId}")) (event_mutation (when (date_merge (nearby)))))`;
};

export const generateScheduleCQL = (calendarIds: string[]) => {
  if (calendarIds.length === 0) {
    // Cannot generate CQL without calendarIds
    return null;
  }
  const attendeeesString = calendarIds.map((calendarId) => `"${calendarId}"`).join(" ");
  return `(create_event (attendees ${attendeeesString}))`;
};
